import { PessoaService } from "../../../../services";

const pessoaService = new PessoaService();

export class MdfeEntity {
  serieDocumento = null;
  fatVeiculoId = null;
  proprietarioVeiculoCpfCnpj = null;
  proprietarioVeiculoUf = null;
  proprietarioVeiculoNome = null;
  reboques = null;
  percursos = null;
  lacres = null;
  pedagios = null;
  contratantes = null;
  ciots = null;
  informacoesAdicionais = null;
  municipiosCarregamento = [];
  nfsSaida = [];
  condutores = [];

  constructor(mdfe) {
    this.serieDocumento = mdfe.serieDocumento;
    this.fatVeiculoId = mdfe.fatVeiculoId;
    this.informacoesAdicionais = mdfe.informacoesAdicionais;
  }

  async setProprietarioVeiculo(veiculo) {
    if (!veiculo) {
      return;
    }
    if (!veiculo.veiculoProprio) {
      const res = await pessoaService.getById(veiculo.intPessoaId);
      if (!res.isAxiosError) {
        this.proprietarioVeiculoCpfCnpj = res.data.cnpjCpf;
        this.proprietarioVeiculoNome = res.data.nomeRazaoSocial;
        if (res.data?.enderecos.length) {
          this.proprietarioVeiculoUf =
            res.data.enderecos[0].cidade.estado.sigla;
        }
      }
    }
  }

  setReboques(reboques) {
    if (reboques?.length) {
      this.reboques = reboques;
    }
  }

  setPercursos(percursos) {
    if (percursos?.length) {
      this.percursos = percursos;
    }
  }

  setMunicipiosCarregamento(municipiosCarregamento) {
    this.municipiosCarregamento = municipiosCarregamento;
  }

  setNfsSaida(nfsSaida) {
    this.nfsSaida = nfsSaida;
  }

  setCondutores(condutores) {
    this.condutores = condutores;
  }

  setLacres(lacres) {
    if (lacres?.length) {
      this.lacres = lacres;
    }
  }

  setPedagios(pedagios) {
    if (pedagios?.length) {
      this.pedagios = pedagios;
    }
  }

  setContratantes(contratantes) {
    if (contratantes?.length) {
      this.contratantes = contratantes;
    }
  }

  setCiots(ciots) {
    if (ciots?.length) {
      this.ciots = ciots;
    }
  }
}
